<div>
  <h1 mat-dialog-title>Submission History</h1>
  <div *ngIf="data.formQualitySubmissions.length; else noSubmissions" class="vertical-scroll">
    <table mat-table [dataSource]="dataSource" data-testid="submission-table">
      <ng-container matColumnDef="sectionLabel">
        <th mat-header-cell *matHeaderCellDef>Measure</th>
        <td mat-cell *matCellDef="let row" class="measure-cell">{{ row.sectionLabel }}</td>
      </ng-container>
      <ng-container matColumnDef="evidenceDate" class="date-cell">
        <th mat-header-cell *matHeaderCellDef>Event Date</th>
        <td mat-cell *matCellDef="let row">
          {{ row.evidenceDate ?? row.evidenceValue | formatDate | empty: '' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="procedureName">
        <th mat-header-cell *matHeaderCellDef>Evidence</th>
        <td mat-cell *matCellDef="let row">{{ row.procedureName }}</td>
      </ng-container>
      <ng-container matColumnDef="dateOfService" class="date-cell">
        <th mat-header-cell *matHeaderCellDef>Date of Service</th>
        <td mat-cell *matCellDef="let row">{{ row.dateOfService | formatDate | empty: '' }}</td>
      </ng-container>
      <ng-container matColumnDef="attachments">
        <th mat-header-cell *matHeaderCellDef>Attachments</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.attachments?.length; else noAttachments">
            <div *ngFor="let attachment of row.attachments">
              <button
                mat-button
                class="attachment-button"
                (click)="onAttachmentDownload(attachment)"
                data-testid="attachment-button"
                [matTooltip]="attachment.data.fileName"
              >
                {{ attachment.data.fileName }}
              </button>
            </div>
          </ng-container>
          <ng-template #noAttachments>&nbsp;</ng-template>
        </td>
      </ng-container>
      <ng-container matColumnDef="submittedInfo">
        <th mat-header-cell *matHeaderCellDef>Submitted</th>
        <td mat-cell *matCellDef="let row">{{ row.submittedDate | formatDate }} by {{ row.submittedUser }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <ng-template #noSubmissions>
    <p data-testid="no-submissions-message">There is no submission history</p>
  </ng-template>
  <mat-dialog-actions class="flex-row flex-space-btw">
    <button mat-flat-button [mat-dialog-close]="false" color="accent">Close</button>
  </mat-dialog-actions>
</div>
